import imgWelton91 from "./img-welton9 (1).webp";
import imgWelton92 from "./img-welton9 (2).webp";
import imgWelton93 from "./img-welton9 (3).webp";
import imgWelton94 from "./img-welton9 (4).webp";

const imgWelton9 = [imgWelton91, imgWelton92, imgWelton93, imgWelton94];

export default imgWelton9;
